import { mapApiResourceToAssistantMessage } from '@/api/assistant/assistantMapping';
import type {
  AssistantBriefStart,
  AssistantBriefStartApiResource,
  AssistantPulse,
  AssistantPulseApiResource,
  AssistantUserPreferences,
  AssistantUserPreferencesApiResource,
} from './assistantProactiveApi.types';

export function mapApiResourceToAssistantPulse(
  resource: AssistantPulseApiResource
): AssistantPulse {
  return {
    isActive: resource.is_active,
    attentionTotal: resource.attention_total,
    attentionSections: resource.attention_sections,
    hints: resource.hints.map(function mapHint(hint) {
      return { key: hint.key, destination: hint.destination, target: hint.target };
    }),
    brief: { kind: resource.brief.kind, status: resource.brief.status },
  };
}

export function mapApiResourceToAssistantUserPreferences(
  resource: AssistantUserPreferencesApiResource
): AssistantUserPreferences {
  return {
    proactiveEnabled: resource.proactive_enabled,
    autoBriefEnabled: resource.auto_brief_enabled,
    workspaceProactiveEnabled: resource.workspace_proactive_enabled,
  };
}

export function mapApiResourceToAssistantBriefStart(
  resource: AssistantBriefStartApiResource
): AssistantBriefStart {
  return {
    conversationId: resource.conversation_id,
    turnId: resource.turn_id,
    userMessage:
      resource.user_message === null
        ? null
        : mapApiResourceToAssistantMessage(resource.user_message),
  };
}
